import { Dev } from "./consoleUtil";

type CacheObjectType = {
  data: any;
  timestamp: number;
};

export const CustomCache = {
  save: (key: string, data: boolean | string | object | [] | number) => {
    try {
      const cacheObject = {
        data,
        timestamp: new Date().getTime(),
      } as CacheObjectType;

      window.localStorage.setItem(key, JSON.stringify(cacheObject));
    } catch (error) {
      console.log(...new Dev("CustomCache [save]", error).Error());
    }
  },

  get: (key: string, hours: number) => {
    try {
      const requiredTimestamp = hours * 60 * 60 * 1000;
      const cachedDataString = window.localStorage.getItem(key);

      if (!cachedDataString) return null;

      const cachedData: CacheObjectType = JSON.parse(cachedDataString);

      const timestampNow = new Date().getTime();
      const timestampDiff = timestampNow - cachedData.timestamp;

      if (timestampDiff > requiredTimestamp) return null;

      return cachedData.data;
    } catch (error) {
      console.log(...new Dev("CustomCache [get]", error).Error());
      return null;
    }
  },
};
